import { resolveModuleSizing } from '../../layout-kernel/index.ts';

export interface ComponentSizingProfile {
  /** 任一维度低于对应值时进入 compact。 */
  compact: number;
  compactHeight: number;
  /** 非 compact 且宽度高于此值时进入 expanded。 */
  expanded: number;
  /** 布局器和外壳都必须遵守的尺寸范围。 */
  minWidth: number;
  minHeight: number;
  maxWidth: number;
  maxHeight: number;
  preferredAspectRatio: number;
  canReflow?: boolean;
}

export const builtinComponentKeys = [
  'probfun.metric-card@1',
  'probfun.rich-text@1',
  'probfun.data-table@1',
  'probfun.parameter-slider@1',
  'probfun.playback-control@1',
  'probfun.action-button@1',
  'probfun.choice@1',
  'probfun.prediction@1',
  'probfun.perspective-toggle@1',
  'probfun.line-series@1',
  'probfun.histogram@1',
  'probfun.bar@1',
  'probfun.scatter@1',
  'probfun.function-plot@1',
  'probfun.formula-display@1',
  'probfun.scene@1',
  'probfun.video@1',
  'probfun.outcome@1',
  'probfun.split-view@1',
] as const;

export type BuiltinComponentKey = typeof builtinComponentKeys[number];

function toDensityProfile(key: BuiltinComponentKey): ComponentSizingProfile {
  const sizing = resolveModuleSizing(key);
  return {
    compact: sizing.compactWidth,
    compactHeight: sizing.compactHeight,
    expanded: sizing.expandedWidth,
    minWidth: sizing.minWidth,
    minHeight: sizing.minHeight,
    maxWidth: sizing.maxWidth,
    maxHeight: sizing.maxHeight,
    preferredAspectRatio: sizing.preferredAspectRatio,
    canReflow: key !== 'probfun.playback-control@1' && key !== 'probfun.action-button@1',
  };
}

export const componentSizingProfiles = Object.fromEntries(
  builtinComponentKeys.map(key => [key, toDensityProfile(key)]),
) as Record<BuiltinComponentKey, ComponentSizingProfile>;

export function componentSizingProfile(key: BuiltinComponentKey): ComponentSizingProfile {
  return componentSizingProfiles[key];
}

export function componentHardMinimum(
  key: BuiltinComponentKey,
): { minWidth: number; minHeight: number } {
  const profile = componentSizingProfile(key);
  return {
    minWidth: profile.minWidth,
    minHeight: profile.minHeight,
  };
}
